//@author: kate

import { jSith } from "../util/jquery-replacement";
import { S25Util } from "../util/s25-util";

export class KeyboardSortableService {
    public static lastElementButton: any = null;
    public static onArrowKey(
        event: any,
        sortableArray: any[],
        compareVar: string,
        compareValue: any,
        customUpDownFn: any,
    ) {
        const sortableHandle = $(event.target);

        jSith.addClass(sortableHandle[0].parentElement, "selectingElement");

        if (this.lastElementButton && sortableHandle[0] !== this.lastElementButton) {
            jSith.removeClass(this.lastElementButton.parentElement, "selectingElement");
        }

        this.lastElementButton = sortableHandle[0];

        const defaultUpDown = (sortableHandle: any, sortableArray: any[], compareValue: any, compareVar: string) => {
            let elementIndex: number | undefined;
            for (let i = 0; i < sortableArray.length; i++) {
                if (S25Util.propertyGet(sortableArray[i], compareVar) === compareValue) {
                    elementIndex = i;
                }
            }
            if (elementIndex === undefined) {
                return;
            }

            let currentElementIndex: number = elementIndex;

            const hostElement = sortableHandle[0] as HTMLElement & {
                _s25KeyboardSortableHandler?: (event: KeyboardEvent) => void;
            };
            const priorHandler = hostElement._s25KeyboardSortableHandler;
            if (priorHandler) {
                hostElement.removeEventListener("keydown", priorHandler);
            }

            const handler = (event: KeyboardEvent): void => {
                if (event.key !== "ArrowUp" && event.key !== "ArrowDown") {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                if (event.key === "ArrowUp") {
                    if (currentElementIndex !== 0) {
                        const movedChunk = sortableArray.splice(currentElementIndex, 1);
                        if (movedChunk?.length) {
                            sortableArray.splice(currentElementIndex - 1, 0, movedChunk[0]);
                            currentElementIndex -= 1;
                            sortableHandle.focus();
                        }
                    }
                }
                if (event.key === "ArrowDown") {
                    if (currentElementIndex < sortableArray.length - 1) {
                        const movedChunk = sortableArray.splice(currentElementIndex, 1);
                        if (movedChunk?.length) {
                            sortableArray.splice(currentElementIndex + 1, 0, movedChunk[0]);
                            currentElementIndex += 1;
                            sortableHandle.focus();
                        }
                    }
                }
            };
            hostElement._s25KeyboardSortableHandler = handler;
            hostElement.addEventListener("keydown", handler);
        };

        customUpDownFn = customUpDownFn || defaultUpDown;
        customUpDownFn(sortableHandle, sortableArray, compareVar, compareValue);
    }
}
